/**
 * Constants for check-in creation steps
 */
export enum CheckInStep {
  TEMPLATE_NAME = 'template_name',  // Step 1: Template & Name selection
  CHANNEL = 'channel'               // Step 2: Communication Channel selection
}

// Legacy step names for backward compatibility
export const LEGACY_STEP_MAPPING = {
  'details': CheckInStep.TEMPLATE_NAME,
  'template': CheckInStep.TEMPLATE_NAME,
  'details_and_template': CheckInStep.TEMPLATE_NAME
}

// Get the numeric step (1-based) from the step name
export function getStepNumber(step: CheckInStep | string): number {
  // First normalize the step name
  const normalizedStep = LEGACY_STEP_MAPPING[step as keyof typeof LEGACY_STEP_MAPPING] || step;
  
  switch (normalizedStep) {
    case CheckInStep.TEMPLATE_NAME:
      return 1;
    case CheckInStep.CHANNEL:
      return 2;
    default:
      return 1;
  }
}

// Map from numeric step (1-based) to step name
export function getStepFromNumber(stepNumber: number): CheckInStep {
  switch (stepNumber) {
    case 1:
      return CheckInStep.TEMPLATE_NAME;
    case 2:
      return CheckInStep.CHANNEL;
    default:
      return CheckInStep.TEMPLATE_NAME;
  }
} 